<template lang="pug">
.campaign-info-display
  el-row.row-content(:gutter="20")
    el-col(:span="10")
      .info_label {{ $t('名称') }}
      .info_content {{ campaignInfo.campaign_name }}
    el-col(:span="14" v-if="star.star_name")
      .info_label {{ $t('明星') }}
      .info_content(
        style="display:flex;align-items:center"
      )
        span {{ star.star_name }}
        template(
          v-if="showStarDetailBtn"
        )
          img(
            src="@/umcc/assets/icon-star.jpg"
          )
          el-button(
            type="text"
            @click="handleClick"
          ) {{ $t('查看明星详情') }}
    el-col(:span="14" v-else-if="campaignInfo.campaign_star")
      .info_label {{ $t('明星') }}
      .info_content {{ campaignInfo.campaign_star.map(i => i.star_name).join('，') }}
  el-row.row-content(:gutter="20")
    el-col(:span="10")
      .info_label {{ $t('合作性质') }}
      .info_content {{ $t(campaignInfo.cooperation_type) }}
    el-col(:span="14" v-if="campaignInfo.start_date && campaignInfo.end_date")
      .info_label {{ $t('合作期限') }}
      .info_content {{ campaignInfo.start_date }} ~ {{ campaignInfo.end_date }}
  el-row.row-content(:gutter="20")
    el-col(:span="24")
      .info_label {{ $t('品类+品牌') }}
      .info_content
        div(
          v-for="(b, i) in campaignInfo.brand"
        ) {{ b.brand_category_name }} - {{ b.brand_name }}
  el-row.row-content(:gutter="20")
    el-col(:span="24")
      .info_label {{ $t('描述') }}
      .info_content {{ campaignInfo.introduction ? campaignInfo.introduction : '—' }}
</template>

<script>
export default {
  props: {
    campaignInfo: {
      type: Object,
      default () {
        return {}
      }
    },
    star: {
      type: Object,
      default () {
        return {}
      }
    },
    showStarDetailBtn: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  methods: {
    handleClick () {
      window.open('https://ul.tezign.com/star/artist_gallery/detail?external_id=' + this.star.external_id, '_blank')
    }
  }
}
</script>

<style lang="stylus">
.campaign-info-display
  .info_content
    img
      width 20px
      height 20px
      margin-left 20px
</style>
